// src/index.js
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";                 // ← 여기!
import "./index.css";
// ↓ 측정 안 하실 거면 이 줄은 지우거나 주석 처리하세요
//import reportWebVitals from "./reportWebVitals";

ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// ↓ 필요 없으면 제거
//reportWebVitals();

